"use strict";function collectSticker$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.collectSticker$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.chat.collectSticker";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.6.25"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.6.25"},_a)),exports.collectSticker$=collectSticker$,exports.default=collectSticker$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/chat/collectSticker.js
// module id = 915
// module chunks = 106